import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Agendamento } from 'src/class/agendamento';
import { Links } from 'src/class/links';
import { objUsuario } from 'src/class/usuario';
import { SearchAgendamentoPipe } from 'src/pipes/search-agendamento.pipe';
import { DataService } from 'src/services/data.service';
import { LinksService } from 'src/services/links.service';
import { ThemeService } from 'src/services/theme.service';
import { ToastService } from 'src/services/toast.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { StatusAgendamento } from '../../../../enum/statusAgendamento.enum';
import { ModalConfirmacaoService } from 'src/services/modal-confirmacao.service';
import { ValidatorService } from 'src/services/validator.service';
import { AgendamentoService } from 'src/services/component/agendamento.service';
import { LocalhostService } from 'src/services/localhost.service';
import { WhatsappService } from 'src/services/whatsapp.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ContaService } from 'src/services/component/conta.service';
// Calendario
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, DatesSetArg, EventContentArg } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import ptbr from '@fullcalendar/core/locales/pt-br';
import { Agenda } from 'src/class/agenda';
import { AgendaService } from 'src/services/component/agenda.service';
import { CalendarioService } from 'src/services/calendario.service';
import multiMonthPlugin from '@fullcalendar/multimonth';
import { NotificacaoSistemaService } from 'src/services/component/notificacao-sistema.service';
import { AuthService } from 'src/services/auth.service';
import { Checkin } from 'src/class/checkin';
import { ContadorIndexService } from 'src/services/contador-index.service';
import { CheckinService } from 'src/services/component/checkin.service';
import { Tipo } from 'src/class/tipo';
import { TipoService } from 'src/services/component/tipo.service';
import { FormControl, Validators } from '@angular/forms';

declare var bootstrap: any;

@Component({
  selector: 'app-agendamentos',
  templateUrl: './agendamentos.component.html',
  styleUrls: ['./agendamentos.component.css']
})
export class AgendamentosComponent implements OnInit,OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @ViewChild('calendarioModal', { static: false }) calendarioModal!: ElementRef;
  @ViewChild('fullcalendar') fullcalendar!: FullCalendarComponent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('naoAtendidoModal', { static: false }) naoAtendidoModal!: ElementRef;
  @ViewChild('filtro', { static: false }) filtro!: ElementRef;
  @ViewChild('infoAgendamentoModal', { static: false }) infoAgendamentoModal!: ElementRef;
  @ViewChild('checkinModal', { static: false }) checkinModal!: ElementRef;

  modalsMap = new Map<ElementRef, any>();

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj = new objUsuario;

  agenda_arr: any [] = [];

  pesquisa="";
  pag = 1;
  contador = 5;
  pageSize = 10;
  pageIndex = 0;
  totalizador = 0;
  maxSize = 10;
  visualizando = this.contador;
  lightMode: any;
  modoView = false;
  modoViewNum = 12;

  private subscription: Subscription;

  linksAgenda: Links[] = [];

  statusAgendamento = StatusAgendamento;

  statusAgendamentoArray: string[] = Object.values(StatusAgendamento);

  agendamentos: Agendamento[] = [];
  displayedAgendamentos: Agendamento[] = [];
  loading: boolean = true;
  sortedData: Agendamento[] = [];

  loader = this.loadingBar.useRef('http');

  naoAtendidoObj: Agendamento = new Agendamento();

  agendamento: Agendamento = new Agendamento();

  statusSelecionados: any[] = [];
  currentDate = new Date();

  status = '';
  classificado = '';
  dataAgendamento = '';
  empresaSigla: any | undefined;

  objInfoAgendamento: Agendamento = new Agendamento();
  objInfoAgenda: Agenda = new Agenda();

  eventsList: any[] = [];
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth', // Define a visualização de lista semanal
    plugins: [dayGridPlugin, multiMonthPlugin, timeGridPlugin, listPlugin],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    locale: ptbr, // Define o idioma para pt-BR
    events: this.eventsList,
    eventClick: this.handleEventClick.bind(this), // Associe um manipulador de eventos para quando um evento for clicado,
    eventDisplay: 'block', // Exibe os eventos em blocos
    eventOverlap: false, // Não permita a sobreposição de eventos
    dayMaxEventRows: 3, // Define o número máximo de linhas de eventos por dia
    nowIndicator: true,
    now: new Date(),
    multiMonthMaxColumns: 1,
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      meridiem: 'short' // Adiciona AM/PM
    },
    allDaySlot: false, // exibir slot de dia inteiro
    // eventContent: this.customEventContent.bind(this),
    // datesSet: this.customDatesSet.bind(this), // Personalize o tamanho das células no modo mês
    // eventContent: function (info) {
    //   const event = info.event;
    //   const description = event.extendedProps['description'] || ''; // Obtenha a descrição do evento

    //   return {
    //     html: `
    //       <div class="event-title">${event.title}</div>
    //       <div class="event-description">${description}</div>
    //       `
    //     };
    // }
  };
  agendas: Agenda[] = [];
  agendaSelecionada: number | null = null;

  tipos: Tipo[] = [];

  filtrado: any;

  new_checkin: Checkin = new Checkin();

  telefoneFormControl = new FormControl('', [
    Validators.required,
  ]);

  pagerFormControl = new FormControl('', [
    Validators.required,
  ]);

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private themeService: ThemeService,
    private linksService: LinksService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
    private paginatorIntl: MatPaginatorIntl,
    private searchAgendamentoPipe: SearchAgendamentoPipe,
    private loadingBar: LoadingBarService,
    private modalConfirmacaoService: ModalConfirmacaoService,
    private notificacaoService: NotificacaoSistemaService,
    private validatorService: ValidatorService,
    private agendamentoService: AgendamentoService,
    private localhostService: LocalhostService,
    private renderer: Renderer2,
    private whatsapp: WhatsappService,
    private siglaService: SiglaService,
    private conta: ContaService,
    private agendaService: AgendaService,
    private calendarioService: CalendarioService,
    private userService: AuthService,
    private checkinService: CheckinService,
    private contadorIndexService: ContadorIndexService,
    private tipoService: TipoService
  ){
    this.subscription = this.themeService.lightMode$.subscribe(lightMode => {
      this.lightMode = lightMode;
    });

    this.paginatorIntl.itemsPerPageLabel = 'Itens por página:';
    this.paginatorIntl.nextPageLabel = 'Próxima página';
    this.paginatorIntl.previousPageLabel = 'Página anterior';
    this.paginatorIntl.firstPageLabel = 'Primeira página';
    this.paginatorIntl.lastPageLabel = 'Última página';

    // Personalize a indexação para começar em 1
    this.paginatorIntl.getRangeLabel = this.getPortugueseRangeLabel;

    // Alimenta o serviço com a empresaSigla
    // this.router.events.subscribe((event) => {
      // if (event instanceof NavigationEnd) {
        this.route.params
        .pipe(takeUntil(this.destroy$))
        .subscribe(async params => {
          this.empresaSigla = params['empresaSigla'];
          await this.agendamentoService.organizarAcesso(); // O organizarAcesso tem que ficar dentro do componente pois no serviço ele acaba não carregando os dados de primeira, somente quando muda e volta para a rota, se apenas pressionar F5 ele não carrega
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
          this.agendamentoService.getAgendamentos(this.empresaSigla);
          this.agendaService.getAgendas(this.empresaSigla);
          this.tipoService.getTipo(this.empresaSigla);
        });
      // }
    // });

  }

  ngOnInit() {
    this.getCache();

    this.linksAgenda = this.linksService.getLinksAgenda();

    this.changeDetectorRef.detectChanges();

    this.route.queryParams.subscribe((params: any) => {
      // O parâmetro de consulta 'search' estará em params.search
      this.pesquisa = params.search ? params.search : '';
      // console.log(params)
      // Agora você pode usar o valor da pesquisa em sua função searchAgenda
      if(this.pesquisa != ''){
        // setTimeout(() => {
          this.searchAgendamento();
          // if (this.filtro && this.filtro.nativeElement) {
          //   console.log(this.filtro)
          //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
          // }
        // }, 500);
      }
    });

    this.agendaService.getAllAgendas()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (agendas: Agenda[]) => {
        // console.log(agendas)
        // Faça algo com as notificações atualizadas
        if(agendas.length > 0){
          this.agendas = agendas;
          this.loading = false;
        }
      },
      error => {
        // console.error('Erro ao listar as Agenda:', error);
      }
    );

    this.tipoService.getAllTipo()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (tipos: Tipo[]) => {
        // console.log(agendas)
        // Faça algo com as notificações atualizadas
        if(tipos.length > 0){
          this.tipos = tipos;
          this.loading = false;
        }
      },
      error => {
        // console.error('Erro ao listar as Agenda:', error);
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  getCache(){

    let modoView = localStorage.getItem("modoView");

    let modoViewNum = localStorage.getItem("modoViewNum");

    if(modoView){
      this.modoView = modoView == 'true' ? true : false
    }

    if(modoViewNum){
      this.modoViewNum = parseInt(modoViewNum);
    }

    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.Tipo;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }

    this.dataAgendamento = 'Hoje';

    this.agendamentoService.getAgendamentosDia()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (agendamentos: Agendamento[]) => {
        // console.log(agendamentos)

        // Faça algo com as notificações atualizadas
        // if(agendamentos.length > 0){
          this.agendamentos = agendamentos;
          this.displayedAgendamentos = this.agendamentos.slice(
            this.pageIndex * this.pageSize,
            (this.pageIndex + 1) * this.pageSize
          );

          this.ordenadoPor('Maior Data/Horário');

          this.loading = false;
          if(this.pesquisa != ''){
            setTimeout(() => {
              this.searchAgendamento();
              // if (this.filtro && this.filtro.nativeElement) {
              //   console.log(this.filtro)
              //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
              // }
            }, 500);
          }

        // }
      },
      error => {
        // console.error('Erro ao listar os Agendamentos:', error);
      }
    );

    // let agendamento = DataService.get("Agendamento");
    // console.log(agendamento)

    // if(agendamento != undefined){
    //   this.agendamentos = agendamento;
    //   this.loading = false;
    // }else{
    //   // this.loading = false;
    //   let agendamentoCache = localStorage.getItem("Agendamento")
    //   if(agendamentoCache != undefined){
    //     this.agendamentos = JSON.parse(agendamentoCache);
    //     DataService.set("Agendamento", JSON.parse(agendamentoCache));
    //     this.loading = false;
    //   }else{
    //     setTimeout(() => {
    //       this.loading = false;
    //     }, 500);
    //   }
    // }

    // console.log(this.loading)

  }

  allAgendamentos(){
    this.dataAgendamento = 'Todos';
    if(this.status == ""){
      this.agendamentoService.getAllAgendamentos()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }
          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }else{
      this.agendamentoService.getStatusAgendamento(this.status)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }
          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }

  }

  agendamentosDia(){
    this.dataAgendamento = 'Hoje';
    if(this.status == ""){
      this.agendamentoService.getAgendamentosDia()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }else{
      this.agendamentoService.getStatusAgendamentoDia(this.status)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }
  }

  agendamentosFuturos(){
    this.dataAgendamento = 'Futuros';
    if(this.status == ""){
      this.agendamentoService.getAgendamentosFuturos()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }else{
      this.agendamentoService.getStatusAgendamentosFuturos(this.status)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }
  }

  agendamentosPassados(){
    this.dataAgendamento = 'Passados';
    if(this.status == ""){
      this.agendamentoService.getAgendamentosPassados()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }else{
      this.agendamentoService.getStatusAgendamentosPassados(this.status)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (agendamentos: Agendamento[]) => {
          // console.log(agendamentos)

          // Faça algo com as notificações atualizadas
          // if(agendamentos.length > 0){
            this.agendamentos = agendamentos;
            this.displayedAgendamentos = this.agendamentos.slice(
              this.pageIndex * this.pageSize,
              (this.pageIndex + 1) * this.pageSize
            );

            this.ordenadoPor(this.classificado);

            this.loading = false;
            if(this.pesquisa != ''){
              setTimeout(() => {
                this.searchAgendamento();
                // if (this.filtro && this.filtro.nativeElement) {
                //   console.log(this.filtro)
                //   this.renderer.selectRootElement(this.filtro.nativeElement).click();
                // }
              }, 500);
            }

          // }
        },
        error => {
          // console.error('Erro ao listar os Agendamentos:', error);
        }
      );
    }
  }

  searchAgendamento(){
    const retorno = this.searchAgendamentoPipe.transform(this.agendamentos, this.pesquisa);

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.displayedAgendamentos = retorno;

    if(this.pesquisa == ""){
      this.displayedAgendamentos = this.agendamentos.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      this.paginator.length = this.agendamentos.length;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { search: null },
        queryParamsHandling: 'merge',
      });

    }else{

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ['search']: this.pesquisa },
        queryParamsHandling: 'merge',
      });

      this.displayedAgendamentos = retorno.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      if (this.paginator) {
        this.paginator.length = retorno.length;
      }
      this.filtrado = retorno.length;
    }
  }

  handlePage(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.maxSize = event.pageSize
    // console.log(event)

    // Calcule o índice de início e fim dos itens a serem exibidos na página atual
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;

    // Atualize os itens a serem exibidos na tabela
    this.displayedAgendamentos = this.agendamentos.slice(startIndex, endIndex);

    // console.log(this.displayedAgendamentos)
  }

  sortData(sort: Sort) {
    // const data = this.agendamentos.slice();
    // if (!sort.active || sort.direction === '') {
    //   this.sortedData = data;
    //   this.agendamentos = this.sortedData
    //   return;
    // }

    // this.sortedData = data.sort((a, b) => {
    //   const isAsc = sort.direction === 'asc';

    //   switch (sort.active) {
    //     case 'id':
    //       return this.compare(a.id!, b.id!, isAsc);
    //     case 'cep':
    //       return this.compare(a.cep.valor, b.cep.valor, isAsc);
    //     case 'logradouro':
    //       return this.compare(a.logradouro.valor, b.logradouro.valor, isAsc);
    //     case 'numero':
    //       return this.compare(a.numero.valor, b.numero.valor, isAsc);
    //     case 'bairro':
    //       return this.compare(a.bairro.valor, b.bairro.valor, isAsc);
    //     case 'localidade':
    //       return this.compare(a.localidade.valor, b.localidade.valor, isAsc);
    //     case 'uf':
    //       return this.compare(a.uf.valor, b.uf.valor, isAsc);
    //     default:
    //       return 0;
    //   }
    // });

    // console.log(this.sortedData)
    // this.agendamentos = this.sortedData

    // this.displayedAgendamentos = this.agendamentos.slice(
    //   this.pageIndex * this.pageSize,
    //   (this.pageIndex + 1) * this.pageSize
    // );
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // Personalize a função getRangeLabel para começar em 1
  getPortugueseRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }

  reload(){
    try {
      this.agendamentos = [];
      this.loading = true;
      // this.getTotalTiposUsuarios();
      // this.getUsuario();


    this.loader.start()

      setTimeout(() => {


        this.statusPor(this.status)
        this.ordenadoPor(this.classificado);

        this.showInfo("Agendamentos atualizados com sucesso!!")
        this.loading = false;
        this.loader.complete()

      }, 1000);


    } catch (error) {
      this.showError("Ocorreu um erro na atualização da agenda")
      this.loader.complete()
    }

  }

  resetSearch(){
    this.pesquisa = "";
    this.filtrado = 0;
    this.displayedAgendamentos = this.agendamentos.slice(
      this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );
    this.paginator.length = this.agendamentos.length;

    // Use o serviço Router para navegar para a mesma rota sem o parâmetro de consulta
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { search: null },
      queryParamsHandling: 'merge',
    });
  }

  pags(pags: any) {
    const target = pags as HTMLTextAreaElement;
    this.contador = parseInt(target.value)
    const total = this.contador * this.pag
    this.visualizando = total;
    if(this.visualizando > this.totalizador && (this.visualizando > 0 && this.totalizador > 0)){
      this.visualizando = this.totalizador;
    }
  }

  modoTabela(){
    this.modoView = true;
    localStorage.setItem("modoView", "true");
  }


  modoCard(){
    this.modoView = false;
    this.modoViewNum = 12;
    localStorage.setItem("modoViewNum", "12");
    localStorage.setItem("modoView", "false");
  }

  deletarAgendamento(id: any){
    const index = this.agendamentos.findIndex(agenda => agenda.id === id);

    if (index !== -1) {

      let titulo = 'Tem certeza que deseja excluir o agendamento?';
      let mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>NF ${this.agendamentos[index].notaFiscal.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            <i class="bi bi-calendar-event"></i> ${this.agendamentos[index].dataAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-stopwatch"></i> ${this.agendamentos[index].duracaoAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock"></i> ${this.agendamentos[index].hora_inicial.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock-history"></i> ${this.agendamentos[index].hora_final.valor}
                          </span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            ${this.agendamentos[index].status.valor === 'Confirmado cliente' || this.agendamentos[index].status.valor === 'Confirmado administrador' ? "<i class='bi bi-circle-fill text-cor-info ag-pr-5'></i>" : this.agendamentos[index].status.valor === 'Atendido' ? "<i class='bi bi-circle-fill text-cor-sucesso ag-pr-5'></i>" : this.agendamentos[index].status.valor === 'Não atendido' ? "<i class='bi bi-circle-fill text-cor-danger ag-pr-5'></i>" : "<i class='bi bi-circle-fill ag-pr-5'></i>"}
                            ${this.agendamentos[index].status.valor}
                          </span>
                        </p>
                      </div>`;

          this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
            if (confirmation) {
              // console.log('SIM!');
              // Encontrou um item com o ID correspondente, exclua-o

              const docId = this.agendamentos[index].id != null ? this.agendamentos[index].id?.toString() : "";

              await this.conta.p_getSiglaConta('contas', this.empresaSigla)
              .then((conta) => {
                // Faça algo com os dados obtidos
                // console.log('Dados da conta: criarAgenda', conta);

                this.localhostService.deleteDados(`${conta.id}_agendamentos`, { id: docId })
                .then(async (response: any) => {
                  // console.log('Atualização bem-sucedida:', response);
                  // Salve o array de volta no DataService
                  // DataService.set("Agenda", this.agendas)
                  // localStorage.setItem("Agenda", JSON.stringify(this.agendas))
                  this.showSuccess(`Agendamento deletado com sucesso`);

                  // Nova notificação
                  // 1 - empresaSigla: any,
                  // 2 - titulo: string,
                  // 3 - texto: string,
                  // 4 - rotaSemParamNome: string,
                  // 5 - rotaSemParamListar: string,
                  // 6 - rotaComParamNome: string = "",
                  // 7 - rotaComParamCaminho: string = "",
                  // 8 - rotaComParamParam: string = "",
                  // 9 - linkExternoNome: string = "",
                  // 10 - linkExternoURL: string = "",
                  // 11 - idReferencia: string,
                  // 12 - tipo: string,
                  // 13 - idResponsavel: string,
                  // 14 - nomeResponsavel: string

                  const usr = await this.userService.carregarUsuario(this.empresaSigla)

                  this.notificacaoService.criarNotificacao(
                    this.empresaSigla,
                    `NF ${this.agendamentos[index].notaFiscal.valor}`,
                    `O agendamento do dia ${this.agendamentos[index].dataAtendimento.valor}, das ${this.agendamentos[index].hora_inicial.valor} às ${this.agendamentos[index].hora_final.valor}, foi deletado.`,
                    'Listar Agendamentos',
                    'agendamentos',
                    '',
                    ``,
                    ``,
                    '',
                    '',
                    this.agendamentos[index].agendaId!.toString(),
                    `Agendamento`,
                    `${usr.id}`,
                    `${usr.displayName.valor}`
                  )

                  this.displayedAgendamentos = this.agendamentos.slice(
                    this.pageIndex * this.pageSize,
                    (this.pageIndex + 1) * this.pageSize
                  );

                  this.reload();
                })
                .catch((error: any) => {
                  // console.error('Erro ao deletar dados:', error);
                  this.showError("Agendamento não encontrado para exclusão \n" + error);
                });
              },
              (error: any) => {
                // console.error('Erro ao atualizar dados:', error);
                // Trate o erro conforme necessário
              }).catch((error) => {
                // Trate o erro
                // this.authService.fazerLogout(this.empresaSigla);
                // console.log('Erro ao obter dados da conta:', error);
              });

            } else {
              // console.log('NÃO');
            }
          });

    } else {
      // Não encontrou um item com o ID correspondente
      this.showError("Agendamento não encontrado para exclusão");
    }
  }

  atualizarStatusAgendamento(id: any, status: string){

    const index = this.agendamentos.findIndex((item: Agendamento) => item.id === id);

    if (index !== -1 && status != '') {
      let titulo = "";
      let mensagem = "";

      switch (status) {
        case this.statusAgendamento.confirmadoAdm:
          titulo = 'Tem certeza que deseja alterar o status?';
          mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>NF ${this.agendamentos[index].notaFiscal.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            <i class="bi bi-calendar-event"></i> ${this.agendamentos[index].dataAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-stopwatch"></i> ${this.agendamentos[index].duracaoAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock"></i> ${this.agendamentos[index].hora_inicial.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock-history"></i> ${this.agendamentos[index].hora_final.valor}
                          </span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-danger">Status atual: </span>
                          <span>${this.agendamentos[index].status.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-sucesso">Novo status: </span>
                          <span>${this.statusAgendamento.confirmadoAdm}</span>
                        </p>
                      </div>`;

          this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
            if (confirmation) {
              // console.log('SIM!');
              // Atualize o item existente
              this.agendamentos[index].status.valor = status;

              const docId = this.agendamentos[index].id != null ? this.agendamentos[index].id?.toString() : "";
              const plainObject = JSON.stringify(this.agendamentos[index])
              const plainString = JSON.parse(plainObject)

              plainString.cpfMotorista.status = null;
              plainString.dataAtendimento.status = null;
              plainString.duracaoAtendimento.status = null;
              plainString.emailMotorista.status = null;
              plainString.fornecedor.status = null;
              plainString.hora_final.status = null;
              plainString.hora_inicial.status = null;
              plainString.nomeMotorista.status = null;
              plainString.notaFiscal.status = null;
              plainString.numeroPedido.status = null;
              plainString.observacao.status = null;
              plainString.placaVeiculo.status = null;
              plainString.telefoneMotorista.status = null;
              plainString.status.status = null;
              plainString.statusExecucao.status = null;

              await this.conta.p_getSiglaConta('contas', this.empresaSigla)
              .then((conta) => {
                // Faça algo com os dados obtidos
                // console.log('Dados da conta: atualizarStatusAgendamento', conta);

                this.localhostService.putDados(`${conta.id}_agendamentos`, docId! , plainString)
                .then(async (response: any) => {
                  // console.log('Atualização bem-sucedida:', response);
                  // Salve o array de volta no DataService
                  // DataService.set("Agenda", this.agendas)
                  // localStorage.setItem("Agenda", JSON.stringify(this.agendas))
                  this.showSuccess(`Status do agendamento NF ${this.agendamentos[index].notaFiscal.valor} alterado para ${this.agendamentos[index].status.valor}`);

                  // Nova notificação
                  // 1 - empresaSigla: any,
                  // 2 - titulo: string,
                  // 3 - texto: string,
                  // 4 - rotaSemParamNome: string,
                  // 5 - rotaSemParamListar: string,
                  // 6 - rotaComParamNome: string = "",
                  // 7 - rotaComParamCaminho: string = "",
                  // 8 - rotaComParamParam: string = "",
                  // 9 - linkExternoNome: string = "",
                  // 10 - linkExternoURL: string = "",
                  // 11 - idReferencia: string,
                  // 12 - tipo: string,
                  // 13 - idResponsavel: string,
                  // 14 - nomeResponsavel: string

                  const usr = await this.userService.carregarUsuario(this.empresaSigla)

                  this.notificacaoService.criarNotificacao(
                    this.empresaSigla,
                    `NF ${this.agendamentos[index].notaFiscal.valor}`,
                    `O status do agendamento do dia ${this.agendamentos[index].dataAtendimento.valor}, das ${this.agendamentos[index].hora_inicial.valor} às ${this.agendamentos[index].hora_final.valor}, foi alterado para ${this.agendamentos[index].status.valor}.`,
                    'Listar Agendamentos',
                    'agendamentos',
                    'Editar Agendamento',
                    `agendamentos/agendamento`,
                    this.agendamentos[index].id!.toString(),
                    '',
                    '',
                    this.agendamentos[index].agendaId!.toString(),
                    `Agendamento`,
                    `${usr.id}`,
                    `${usr.displayName.valor}`
                  )
                  // const mensagemJSON = {
                  //   "messaging_product": "whatsapp",
                  //   "to": `55${this.agendamentos[index].telefoneMotorista.valor.replace(/\D/g, '')}`,
                  //   "type": "template",
                  //   "template": {
                  //       "name": "atualizao_de_agendamento",
                  //       "language": { "code": "pt_BR" },
                  //       "components": [
                  //           {
                  //               "type": "BODY",
                  //               "parameters": [
                  //                   {
                  //                       "type": "text",
                  //                       "text": `${this.agendamentos[index].notaFiscal.valor}`
                  //                   },
                  //                   {
                  //                       "type": "text",
                  //                       "text": `${this.agendamentos[index].dataAtendimento.valor}`
                  //                   },
                  //                   {
                  //                       "type": "text",
                  //                       "text": `${this.agendamentos[index].hora_inicial.valor}`
                  //                   },
                  //                   {
                  //                       "type": "text",
                  //                       "text": `${this.agendamentos[index].status.valor}`
                  //                   },
                  //                   {
                  //                       "type": "text",
                  //                       "text": `Obrigado!`
                  //                   }
                  //               ]
                  //           }
                  //       ]
                  //   },
                  //   "metadata": {
                  //       "agendamento_id": this.agendamentos[index].agendaId
                  //   }
                  // };

                  // this.whatsapp.enviarMensagem(mensagemJSON)

                  this.enviarEmailAgendamentoAtualizacao(this.agendamentos[index]);

                })
                .catch((error: any) => {
                  // console.error('Erro ao atualizar dados:', error);
                  this.showError("Agendamento não encontrado para atualização \n" + error);
                });
              },
              (error: any) => {
                // console.error('Erro ao atualizar dados:', error);
                // Trate o erro conforme necessário
              }).catch((error) => {
                // Trate o erro
                // this.authService.fazerLogout(this.empresaSigla);
                // console.log('Erro ao obter dados da conta:', error);
              });



              // localStorage.setItem("Agendamento", JSON.stringify(this.agendamentos))
              // this.showSuccess(`Agendamento alterado para ${this.agendamentos[index].status.valor}`);

            } else {
              // console.log('NÃO');
            }
          });

          break;
        case this.statusAgendamento.atendido:
          titulo = 'Tem certeza que deseja alterar o status?';
          mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>NF ${this.agendamentos[index].notaFiscal.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            <i class="bi bi-calendar-event"></i> ${this.agendamentos[index].dataAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-stopwatch"></i> ${this.agendamentos[index].duracaoAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock"></i> ${this.agendamentos[index].hora_inicial.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock-history"></i> ${this.agendamentos[index].hora_final.valor}
                          </span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-danger">Status atual: </span>
                          <span>${this.agendamentos[index].status.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-sucesso">Novo status: </span>
                          <span>${this.statusAgendamento.atendido}</span>
                        </p>
                      </div>`;

          this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
            if (confirmation) {
              // console.log('SIM!');
              // Atualize o item existente

              this.new_checkin = new Checkin();
              console.log(["this.new_checkin",this.new_checkin])
              this.new_checkin.atendimentoId = this.agendamentos[index].id;
              this.new_checkin.nomeMotorista.valor = this.agendamentos[index].nomeMotorista.valor;
              this.new_checkin.cpfMotorista.valor = this.agendamentos[index].cpfMotorista.valor;
              this.new_checkin.placaVeiculo.valor = this.agendamentos[index].placaVeiculo.valor;
              this.new_checkin.veiculo.valor = this.agendamentos[index].veiculo.valor;
              this.new_checkin.peso.valor = this.agendamentos[index].peso.valor;
              this.new_checkin.telefoneMotorista.valor = this.agendamentos[index].telefoneMotorista.valor;
              this.new_checkin.emailMotorista.valor = this.agendamentos[index].emailMotorista.valor;
              this.new_checkin.notaFiscal.valor = this.agendamentos[index].notaFiscal.valor;
              this.new_checkin.numeroPedido.valor = this.agendamentos[index].numeroPedido.valor;
              this.new_checkin.fornecedor.valor = this.agendamentos[index].fornecedor.valor;

              this.abrirModal(this.checkinModal.nativeElement);

              // this.agendamentos[index].status.valor = status;
              // this.agendamentos[index].statusExecucao.valor = this.agendamentos[index].statusExecucaoOptions[0].nome;


              // const docId = this.agendamentos[index].id != null ? this.agendamentos[index].id?.toString() : "";
              // const plainObject = JSON.stringify(this.agendamentos[index])
              // const plainString = JSON.parse(plainObject)

              // plainString.cpfMotorista.status = null;
              // plainString.dataAtendimento.status = null;
              // plainString.duracaoAtendimento.status = null;
              // plainString.emailMotorista.status = null;
              // plainString.fornecedor.status = null;
              // plainString.hora_final.status = null;
              // plainString.hora_inicial.status = null;
              // plainString.nomeMotorista.status = null;
              // plainString.notaFiscal.status = null;
              // plainString.numeroPedido.status = null;
              // plainString.observacao.status = null;
              // plainString.placaVeiculo.status = null;
              // plainString.telefoneMotorista.status = null;
              // plainString.status.status = null;
              // plainString.statusExecucao.status = null;

              // await this.conta.p_getSiglaConta('contas', this.empresaSigla)
              // .then((conta) => {

              //   this.localhostService.putDados(`${conta.id}_agendamentos`, docId! , plainString)
              //   .then(async (response: any) => {

              //     this.showSuccess(`Status do agendamento NF ${this.agendamentos[index].notaFiscal.valor} alterado para ${this.agendamentos[index].status.valor }`);

              //     // Nova notificação
              //     // 1 - empresaSigla: any,
              //     // 2 - titulo: string,
              //     // 3 - texto: string,
              //     // 4 - rotaSemParamNome: string,
              //     // 5 - rotaSemParamListar: string,
              //     // 6 - rotaComParamNome: string = "",
              //     // 7 - rotaComParamCaminho: string = "",
              //     // 8 - rotaComParamParam: string = "",
              //     // 9 - linkExternoNome: string = "",
              //     // 10 - linkExternoURL: string = "",
              //     // 11 - idReferencia: string,
              //     // 12 - tipo: string,
              //     // 13 - idResponsavel: string,
              //     // 14 - nomeResponsavel: string

              //     const usr = await this.userService.carregarUsuario(this.empresaSigla)

              //     this.notificacaoService.criarNotificacao(
              //       this.empresaSigla,
              //       `NF ${this.agendamentos[index].notaFiscal.valor}`,
              //       `O status do agendamento do dia ${this.agendamentos[index].dataAtendimento.valor}, das ${this.agendamentos[index].hora_inicial.valor} às ${this.agendamentos[index].hora_final.valor}, foi alterado para ${this.agendamentos[index].status.valor}.`,
              //       'Listar Agendamentos',
              //       'agendamentos',
              //       'Editar Agendamento',
              //       `agendamentos/agendamento`,
              //       this.agendamentos[index].id!.toString(),
              //       '',
              //       '',
              //       this.agendamentos[index].agendaId!.toString(),
              //       `Agendamento`,
              //       `${usr.id}`,
              //       `${usr.displayName.valor}`
              //     )

              //     this.enviarEmailAgendamentoAtendido(this.agendamentos[index]);

              //   })
              //   .catch((error: any) => {
                  // console.error('Erro ao atualizar dados:', error);
              //     this.showError("Agendamento não encontrado para atualização \n" + error);
              //   });
              // },
              // (error: any) => {
                // console.error('Erro ao atualizar dados:', error);
              // }).catch((error) => {
              //   // this.authService.fazerLogout(this.empresaSigla);
              //   // console.log('Erro ao obter dados da conta:', error);
              // });

            } else {
              // console.log('NÃO');
            }
          });

          break;
        case this.statusAgendamento.naoAtendido:
          titulo = 'Tem certeza que deseja alterar o status?';
          mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>NF ${this.agendamentos[index].notaFiscal.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span>
                            <i class="bi bi-calendar-event"></i> ${this.agendamentos[index].dataAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-stopwatch"></i> ${this.agendamentos[index].duracaoAtendimento.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock"></i> ${this.agendamentos[index].hora_inicial.valor}
                          </span>
                          <span class="ag-pl-5 ag-pr-5">
                            -
                          </span>
                          <span>
                            <i class="bi bi-clock-history"></i> ${this.agendamentos[index].hora_final.valor}
                          </span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-danger">Status atual: </span>
                          <span>${this.agendamentos[index].status.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-sucesso">Novo status: </span>
                          <span>${this.statusAgendamento.naoAtendido}</span>
                        </p>
                      </div>`;

          this.modalConfirmacaoService.openModal(titulo, mensagem).then((confirmation: boolean) => {
            if (confirmation) {
              // console.log('SIM!');
              // Atualize o item existente

              this.naoAtendidoObj = Object.assign(new Agendamento(), this.agendamentos[index]);
              this.abrirModal(this.naoAtendidoModal.nativeElement);
              // console.log(this.naoAtendidoObj)
              // this.agendamentos[index].status.valor = status;
              // localStorage.setItem("Agendamento", JSON.stringify(this.agendamentos))
              // this.showSuccess(`Agendamento alterado para ${this.agendamentos[index].status.valor}`);
            } else {
              // console.log('NÃO');
              this.naoAtendidoObj = new Agendamento();
              // console.log(this.naoAtendidoObj)
            }
          });

          break;
        default:
          break;
      }

    } else {
      // O item não foi encontrado no array, você pode tratar isso conforme necessário
      this.showError("Agendamento não encontrada para atualização");
    }
  }

  async enviarEmailAgendamentoAtualizacao(agendamentoObj: any){
    // console.log(agendamentoObj)

    if(this.empresaSigla != ''){
      const conta = await this.conta.p_getSiglaConta('contas', this.empresaSigla);
      // console.log(conta)
      const templateInicio = `<!DOCTYPE html PUBLIC ' -//W3C//DTD XHTML 1.0 Transitional//EN' 'http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd'> <html xmlns='http://www.w3.org/1999/xhtml'> <head> <!--[if mso]> <style> h2 { font-weight:bold; } h4 { font-weight:bold; } </style> <![endif]--> <title>LOGWISE</title> <meta http-equiv='content-type' content='text/html; charset=utf-8' /> <meta name='viewport' content='width=device-width, initial-scale=1.0' /> <link href='https://fonts.googleapis.com/css?family=Roboto:400,500,700' rel='stylesheet' /> <style type='text/css'> * { -ms-text-size-adjust: 100%; -webkit-text-size-adjust: none; -webkit-text-resize: 100%; text-resize: 100%; } html { font-size: 100%; -webkit-text-size-adjust: 100%; font-variant-ligatures: none; -webkit-font-variant-ligatures: none; text-rendering: optimizeLegibility; -moz-osx-font-smoothing: grayscale; font-smoothing: antialiased; -webkit-font-smoothing: antialiased; text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px; } body { font-family: 'Roboto', sans-serif, 'Arial'; } a { cursor: pointer !important; outline: none; color: #0361ff !important; text-decoration: none; -webkit-transition: all 0.3s ease; -moz-transition: all 0.3s ease; -ms-transition: all 0.3s ease; transition: all 0.3s ease; } a:hover { text-decoration: none !important; opacity: 0.9; } h2 { font-size: 18px; margin: 0; } h4 { font-size: 14px; margin: 0; } h5 { font-size: 13px; margin: 0; } span { line-height: 18px; } #info-panel span, #info-panel p { font-weight: 400; } #info-panel h4 { line-height: 24px; } .panel { padding: 15px 15px 15px; min-width: 280px; border-radius: 15px;} .title a:hover { text-decoration: underline !important; } .title-2 a:hover { text-decoration: underline !important; } .legal { line-height: 16px; } .btn:hover { opacity: 0.9; } .btn a:hover { text-decoration: none !important; } table td { border-collapse: collapse !important; } .ExternalClass, .ExternalClass a, .ExternalClass span, .ExternalClass b, .ExternalClass br, .ExternalClass p, .ExternalClass div { line-height: inherit; } @media only screen and (max-width: 500px) { table[class='legal'] { line-height: normal !important; } } @media only screen and (max-width: 500px) { table[class='flexible'] { width: 100% !important; } } @media only screen and (max-width: 500px) { table[class='center'] { float: none !important; margin: 0 auto !important; } } @media only screen and (max-width: 500px) { [class='hide'] { display: none !important; width: 0 !important; height: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important; } } @media only screen and (max-width: 500px) { td[class='aligncenter'] { text-align: center !important; } } @media only screen and (max-width: 500px) { th[class='flex'] { display: block !important; width: 100% !important; } } @media only screen and (max-width: 500px) { td[class='wrapper'] { padding: 0 !important; } } @media only screen and (max-width: 500px) { td[class='holder'] { padding: 30px 15px 20px !important; } } @media only screen and (max-width: 500px) { td[class='h-auto'] { height: auto !important; } } @media only screen and (max-width: 500px) { td[class='description'] { padding: 30px 20px !important; } } @media only screen and (max-width: 500px) { td[class='i-120'] img { width: 120px !important; height: auto !important; } } @media only screen and (max-width: 500px) { td[class='footer'] td[class='aligncenter'] { line-height: 25px !important; padding: 0 !important; } } @media only screen and (max-width: 500px) { tr[class='table-holder'] { display: table !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='thead'] { display: table-header-group !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='tfoot'] { display: table-footer-group !important; width: 100% !important; } } </style> </head> <body style='margin:0; padding:0;' bgcolor='#ebeff3'> <table style='min-width:320px;' width='100%' cellspacing='0' cellpadding='0' bgcolor='#ebeff3' > <!-- fix for gmail --> <tr> <td class='hide'> <table width='600' cellpadding='0' cellspacing='0' style='width:600px !important;' > <tr> <td style='min-width:600px;font-size:0;line-height:0;'></td> </tr> </table> </td> </tr> <tr> <td class='wrapper' style='padding:30px 10px 0 10px;'> <!-- MAIN BODY --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' style='padding: 0px 0px 0px;border-radius: 5px;background: linear-gradient(0deg,#ffffff 0%,#ffffff 100%);border: 1.5px solid #ececec;box-shadow: rgb(0 0 0 / 5%) 0px 6px 12px;' bgcolor='#FFFFFF' > <table width='100%' cellpadding='0' cellspacing='0'>`
      const templateLogo = `<!-- Logo --> <tr> <td class='logo' align='center'> <img src='${conta.logoURL.valor}' style='vertical-align:top; width: 169px; margin-bottom: 30px; margin-top: 50px;' alt='bSC35mL.jpg' /> </td> </tr>`;
      const templateHeadingTitle = `<!-- Heading Title --> <tr> <td align='center' style='font-weight:500 !important;' > <h2 style='color:#333240;line-height:21px;'> Agendamento </h2> </td> </tr>`;
      const templateInfoPanelInicio = `<!-- Info Panel --> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' >`;
      const templateInfoPanelTitle = `<h4>Nota Fiscal ${agendamentoObj.notaFiscal.valor}</h4><span>`;
      const templateInfoPanelMensagem = `<br> Seu agendamento para o dia <strong>${agendamentoObj.dataAtendimento.valor}</strong> às <strong>${agendamentoObj.hora_inicial.valor}</strong> teve uma atualização: <br><br>`;

      let corBg = '';
      let corTxt = '';

      switch (agendamentoObj.status.valor) {
        case 'Confirmado Cliente':
          corBg = '#ffc107';
          corTxt = '#fff';
          break;
        case 'Confirmado Administrador':
          corBg = '#1a68bf';
          corTxt = '#fff';
          break;
        case 'Atendido':
          corBg = '#38a713';
          corTxt = '#fff';
          break;
        case 'Não Atendido':
          corBg = '#d6050b';
          corTxt = '#fff';
          break;
        default:
          corBg = '#333240';
          corTxt = '#fff';
          break;
      }

      const templateInfoPanelStatus = `<span style='display: block;margin-bottom: 5px;'>Status do agendamento</span> <span style='background:${corBg};padding:3px 10px 2px;border:2px solid ${corBg};border-radius:15px!important;color:${corTxt};text-transform:uppercase;letter-spacing:1px;font-weight: 600;display:block;text-align:center;font-size: 13px;'>${agendamentoObj.status.valor}</span><br>`;
      const templateInfoPanelInfo = `Em breve, você receberá mais detalhes sobre o andamento do seu agendamento.<br> </span>`;
      const templateInfoPanelFinal = `</td></tr></table></td></tr>`;

      const templateSeparador = `<tr> <td><hr style='margin-top: 25px;border: 0px solid !important;border-top: 1px dashed #eceff3 !important;'></td> </tr>`;

      const templateInfoPanelContato = `<!-- Info Panel Contato--> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px; padding:0px 0px 50px 0px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' > <h4>Ficou com dúvidas?</h4> <p style='font-size: 13px; margin: 0px;'>Entre em contato conosco pelos seguintes canais de atendimento:</p> <span> <!-- === CHANGE ME === --> <br>`;

      let templateInfoPanelContatoTelefone = ``;
      let templateInfoPanelContatoWhatsApp = ``;
      let templateInfoPanelContatoEmail = ``;

      if(conta.telefone.valor != ""){
        templateInfoPanelContatoTelefone = `<h4>Telefone</h4> <a target='_blank' href='tel:0${conta.telefone.valor.replace(/\D/g, "")}'>${conta.telefone.valor}</a> <br><br>`;
      }

      if(conta.whatsapp.valor != ""){
        templateInfoPanelContatoWhatsApp = `<h4>WhatsApp</h4> <a target='_blank' href='https://api.whatsapp.com/send?phone=55${conta.whatsapp.valor.replace(/\D/g, "")}&text=Agendamento%20Nota%20${agendamentoObj.notaFiscal.valor}'>${conta.whatsapp.valor}</a> <br><br>`;
      }

      if(conta.email.valor != ""){
        templateInfoPanelContatoEmail = `<h4>E-mail</h4> <a target='_blank' href='mailto:${conta.email.valor}'>${conta.email.valor}</a> <br><br>`
      }

      const templateInfoPanelContatoEndereco = `<h4>Endereço</h4> ${conta.logradouro.valor} ${conta.numero.valor}, ${conta.bairro.valor}<br> ${conta.localidade.valor}-${conta.uf.valor} - ${conta.cep.valor}<br> ${conta.complemento.valor}<br><br>`;

      const linkComoChegar = this.gerarLinkMaps(conta.logradouro.valor, conta.numero.valor, conta.bairro.valor, conta.localidade.valor, conta.uf.valor, conta.cep.valor);

      const templateInfoPanelContatoLinkEndereco = `<a  target='_blank' class='btn' style='margin-top: 5px;margin-bottom: 5px;display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: center;font-size: 10px !important;padding: 4px 8px !important;font-weight: 500;letter-spacing: .4px;background: #f46221;color: #fff !important;width: 100px;border-radius: 5px;' href='${linkComoChegar}'> Como chegar ? </a>`
      // gerarLinkMaps(logradouro: string, numero: string, bairro: string, localidade: string, uf: string, cep: string)

      const templateFinal = `</span> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> <!-- FOOTER --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='footer'> <table width='100%' cellpadding='0' cellspacing='0'> <tr class='table-holder'> <th class='tfoot' width='400' align='center' style='vertical-align:top;padding:0;' > <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td class='aligncenter legal' style='font-size: 12px;color: #444444;font-weight:400;text-align:center;padding: 25px 5px 0px 5px;' > Este e-mail e seus anexos são confidenciais e destinados exclusivamente ao destinatário indicado. Se você não é o destinatário dessa mensagem, qualquer leitura, uso, divulgação, cópia ou disseminação de toda ou parte desta mensagem e/ou os anexos associados são expressamente proibidos. </td> </tr> </table> <table width='100%' cellpadding='0' cellspacing='0' class='center' > <tr> <td height='15'></td> </tr> <tr> <td style='padding:0 10px 0 0;'> <table width='155' align='center' style='height:45px;margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td align='center' style='background-repeat:no-repeat;' > <img src='https://firebasestorage.googleapis.com/v0/b/logwise-dev-9cf97.appspot.com/o/logwise%2Flogwise-logo-padrao-branco.png?alt=media' style='width: 130px;'/> </td> </tr> </table> </td> </tr> <tr> <td height='50'></td> </tr> </table> </th> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <!-- fix for gmail --> <tr> <td style='line-height:0;'> <div style='display:none;white-space:nowrap;font:15px/1px courier;' ></div> </td> </tr> </table> </body> </html>`

      const template = templateInicio + templateLogo + templateHeadingTitle + templateInfoPanelInicio + templateInfoPanelTitle + templateInfoPanelMensagem + templateInfoPanelStatus + templateInfoPanelInfo + templateInfoPanelFinal + templateSeparador + templateInfoPanelContato + templateInfoPanelContatoTelefone + templateInfoPanelContatoWhatsApp + templateInfoPanelContatoEmail + templateInfoPanelContatoEndereco + templateInfoPanelContatoLinkEndereco + templateFinal;

      let emails = new Set<string>(); // Inicializa um Set vazio para evitar duplicatas

      emails.add(agendamentoObj.emailMotorista.valor); // Adiciona o e-mail do motorista

      const id_obj = this.agendas.findIndex(ag => ag.id === agendamentoObj.agendaId);

      if (id_obj !== -1 && this.agendas[id_obj].notificacoes.valor) {
        this.agendas[id_obj].notificacoes.emails!.forEach(email => emails.add(email)); // Adiciona e-mails sem repetição
      }

      const emailsArray = Array.from(emails); // Converte o Set de volta para array

      this.localhostService.enviarEmailAgendamento(emailsArray, `Agendamento - Nota Fiscal ${agendamentoObj.notaFiscal.valor}`, template);
    }
  }

  async enviarEmailAgendamentoAtendido(agendamentoObj: any){
    // console.log(agendamentoObj)

    if(this.empresaSigla != ''){
      const conta = await this.conta.p_getSiglaConta('contas', this.empresaSigla);
      // console.log(conta)
      const templateInicio = `<!DOCTYPE html PUBLIC ' -//W3C//DTD XHTML 1.0 Transitional//EN' 'http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd'> <html xmlns='http://www.w3.org/1999/xhtml'> <head> <!--[if mso]> <style> h2 { font-weight:bold; } h4 { font-weight:bold; } </style> <![endif]--> <title>LOGWISE</title> <meta http-equiv='content-type' content='text/html; charset=utf-8' /> <meta name='viewport' content='width=device-width, initial-scale=1.0' /> <link href='https://fonts.googleapis.com/css?family=Roboto:400,500,700' rel='stylesheet' /> <style type='text/css'> * { -ms-text-size-adjust: 100%; -webkit-text-size-adjust: none; -webkit-text-resize: 100%; text-resize: 100%; } html { font-size: 100%; -webkit-text-size-adjust: 100%; font-variant-ligatures: none; -webkit-font-variant-ligatures: none; text-rendering: optimizeLegibility; -moz-osx-font-smoothing: grayscale; font-smoothing: antialiased; -webkit-font-smoothing: antialiased; text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px; } body { font-family: 'Roboto', sans-serif, 'Arial'; } a { cursor: pointer !important; outline: none; color: #0361ff !important; text-decoration: none; -webkit-transition: all 0.3s ease; -moz-transition: all 0.3s ease; -ms-transition: all 0.3s ease; transition: all 0.3s ease; } a:hover { text-decoration: none !important; opacity: 0.9; } h2 { font-size: 18px; margin: 0; } h4 { font-size: 14px; margin: 0; } h5 { font-size: 13px; margin: 0; } span { line-height: 18px; } #info-panel span, #info-panel p { font-weight: 400; } #info-panel h4 { line-height: 24px; } .panel { padding: 15px 15px 15px; min-width: 280px; border-radius: 15px;} .title a:hover { text-decoration: underline !important; } .title-2 a:hover { text-decoration: underline !important; } .legal { line-height: 16px; } .btn:hover { opacity: 0.9; } .btn a:hover { text-decoration: none !important; } table td { border-collapse: collapse !important; } .ExternalClass, .ExternalClass a, .ExternalClass span, .ExternalClass b, .ExternalClass br, .ExternalClass p, .ExternalClass div { line-height: inherit; } @media only screen and (max-width: 500px) { table[class='legal'] { line-height: normal !important; } } @media only screen and (max-width: 500px) { table[class='flexible'] { width: 100% !important; } } @media only screen and (max-width: 500px) { table[class='center'] { float: none !important; margin: 0 auto !important; } } @media only screen and (max-width: 500px) { [class='hide'] { display: none !important; width: 0 !important; height: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important; } } @media only screen and (max-width: 500px) { td[class='aligncenter'] { text-align: center !important; } } @media only screen and (max-width: 500px) { th[class='flex'] { display: block !important; width: 100% !important; } } @media only screen and (max-width: 500px) { td[class='wrapper'] { padding: 0 !important; } } @media only screen and (max-width: 500px) { td[class='holder'] { padding: 30px 15px 20px !important; } } @media only screen and (max-width: 500px) { td[class='h-auto'] { height: auto !important; } } @media only screen and (max-width: 500px) { td[class='description'] { padding: 30px 20px !important; } } @media only screen and (max-width: 500px) { td[class='i-120'] img { width: 120px !important; height: auto !important; } } @media only screen and (max-width: 500px) { td[class='footer'] td[class='aligncenter'] { line-height: 25px !important; padding: 0 !important; } } @media only screen and (max-width: 500px) { tr[class='table-holder'] { display: table !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='thead'] { display: table-header-group !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='tfoot'] { display: table-footer-group !important; width: 100% !important; } } </style> </head> <body style='margin:0; padding:0;' bgcolor='#ebeff3'> <table style='min-width:320px;' width='100%' cellspacing='0' cellpadding='0' bgcolor='#ebeff3' > <!-- fix for gmail --> <tr> <td class='hide'> <table width='600' cellpadding='0' cellspacing='0' style='width:600px !important;' > <tr> <td style='min-width:600px;font-size:0;line-height:0;'></td> </tr> </table> </td> </tr> <tr> <td class='wrapper' style='padding:30px 10px 0 10px;'> <!-- MAIN BODY --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' style='padding: 0px 0px 0px;border-radius: 5px;background: linear-gradient(0deg,#ffffff 0%,#ffffff 100%);border: 1.5px solid #ececec;box-shadow: rgb(0 0 0 / 5%) 0px 6px 12px;' bgcolor='#FFFFFF' > <table width='100%' cellpadding='0' cellspacing='0'>`
      const templateLogo = `<!-- Logo --> <tr> <td class='logo' align='center'> <img src='${conta.logoURL.valor}' style='vertical-align:top; width: 169px; margin-bottom: 30px; margin-top: 50px;' alt='bSC35mL.jpg' /> </td> </tr>`;
      const templateHeadingTitle = `<!-- Heading Title --> <tr> <td align='center' style='font-weight:500 !important;' > <h2 style='color:#333240;line-height:21px;'> Agendamento </h2> </td> </tr>`;
      const templateInfoPanelInicio = `<!-- Info Panel --> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' >`;
      const templateInfoPanelTitle = `<h4>Nota Fiscal ${agendamentoObj.notaFiscal.valor}</h4><span>`;
      const templateInfoPanelMensagem = `<br> Seu agendamento para o dia <strong>${agendamentoObj.dataAtendimento.valor}</strong> às <strong>${agendamentoObj.hora_inicial.valor}</strong> teve uma atualização: <br><br>`;

      let corBg = '';
      let corTxt = '';

      switch (agendamentoObj.status.valor) {
        case 'Confirmado Cliente':
          corBg = '#ffc107';
          corTxt = '#fff';
          break;
        case 'Confirmado Administrador':
          corBg = '#1a68bf';
          corTxt = '#fff';
          break;
        case 'Atendido':
          corBg = '#38a713';
          corTxt = '#fff';
          break;
        case 'Não Atendido':
          corBg = '#d6050b';
          corTxt = '#fff';
          break;
        default:
          corBg = '#333240';
          corTxt = '#fff';
          break;
      }

      const templateInfoPanelStatus = `<span style='display: block;margin-bottom: 5px;'>Status do agendamento</span> <span style='background:${corBg};padding:3px 10px 2px;border:2px solid ${corBg};border-radius:15px!important;color:${corTxt};text-transform:uppercase;letter-spacing:1px;font-weight: 600;display:block;text-align:center;font-size: 13px;'>${agendamentoObj.status.valor}</span><br>`;
      const templateInfoPanelInfo = `Seu agendamento foi finalizado.<br>Obrigado.<br> </span>`;
      const templateInfoPanelFinal = `</td></tr></table></td></tr>`;

      const templateSeparador = `<tr> <td><hr style='margin-top: 25px;border: 0px solid !important;border-top: 1px dashed #eceff3 !important;'></td> </tr>`;

      const templateInfoPanelContato = `<!-- Info Panel Contato--> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px; padding:0px 0px 50px 0px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' > <h4>Ficou com dúvidas?</h4> <p style='font-size: 13px; margin: 0px;'>Entre em contato conosco pelos seguintes canais de atendimento:</p> <span> <!-- === CHANGE ME === --> <br>`;

      let templateInfoPanelContatoTelefone = ``;
      let templateInfoPanelContatoWhatsApp = ``;
      let templateInfoPanelContatoEmail = ``;

      if(conta.telefone.valor != ""){
        templateInfoPanelContatoTelefone = `<h4>Telefone</h4> <a target='_blank' href='tel:0${conta.telefone.valor.replace(/\D/g, "")}'>${conta.telefone.valor}</a> <br><br>`;
      }

      if(conta.whatsapp.valor != ""){
        templateInfoPanelContatoWhatsApp = `<h4>WhatsApp</h4> <a target='_blank' href='https://api.whatsapp.com/send?phone=55${conta.whatsapp.valor.replace(/\D/g, "")}&text=Agendamento%20Nota%20${agendamentoObj.notaFiscal.valor}'>${conta.whatsapp.valor}</a> <br><br>`;
      }

      if(conta.email.valor != ""){
        templateInfoPanelContatoEmail = `<h4>E-mail</h4> <a target='_blank' href='mailto:${conta.email.valor}'>${conta.email.valor}</a> <br><br>`
      }

      const templateInfoPanelContatoEndereco = `<h4>Endereço</h4> ${conta.logradouro.valor} ${conta.numero.valor}, ${conta.bairro.valor}<br> ${conta.localidade.valor}-${conta.uf.valor} - ${conta.cep.valor}<br> ${conta.complemento.valor}<br><br>`;

      const linkComoChegar = this.gerarLinkMaps(conta.logradouro.valor, conta.numero.valor, conta.bairro.valor, conta.localidade.valor, conta.uf.valor, conta.cep.valor);

      const templateInfoPanelContatoLinkEndereco = `<a  target='_blank' class='btn' style='margin-top: 5px;margin-bottom: 5px;display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: center;font-size: 10px !important;padding: 4px 8px !important;font-weight: 500;letter-spacing: .4px;background: #f46221;color: #fff !important;width: 100px;border-radius: 5px;' href='${linkComoChegar}'> Como chegar ? </a>`
      // gerarLinkMaps(logradouro: string, numero: string, bairro: string, localidade: string, uf: string, cep: string)

      const templateFinal = `</span> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> <!-- FOOTER --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='footer'> <table width='100%' cellpadding='0' cellspacing='0'> <tr class='table-holder'> <th class='tfoot' width='400' align='center' style='vertical-align:top;padding:0;' > <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td class='aligncenter legal' style='font-size: 12px;color: #444444;font-weight:400;text-align:center;padding: 25px 5px 0px 5px;' > Este e-mail e seus anexos são confidenciais e destinados exclusivamente ao destinatário indicado. Se você não é o destinatário dessa mensagem, qualquer leitura, uso, divulgação, cópia ou disseminação de toda ou parte desta mensagem e/ou os anexos associados são expressamente proibidos. </td> </tr> </table> <table width='100%' cellpadding='0' cellspacing='0' class='center' > <tr> <td height='15'></td> </tr> <tr> <td style='padding:0 10px 0 0;'> <table width='155' align='center' style='height:45px;margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td align='center' style='background-repeat:no-repeat;' > <img src='https://firebasestorage.googleapis.com/v0/b/logwise-dev-9cf97.appspot.com/o/logwise%2Flogwise-logo-padrao-branco.png?alt=media' style='width: 130px;'/> </td> </tr> </table> </td> </tr> <tr> <td height='50'></td> </tr> </table> </th> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <!-- fix for gmail --> <tr> <td style='line-height:0;'> <div style='display:none;white-space:nowrap;font:15px/1px courier;' ></div> </td> </tr> </table> </body> </html>`

      const template = templateInicio + templateLogo + templateHeadingTitle + templateInfoPanelInicio + templateInfoPanelTitle + templateInfoPanelMensagem + templateInfoPanelStatus + templateInfoPanelInfo + templateInfoPanelFinal + templateSeparador + templateInfoPanelContato + templateInfoPanelContatoTelefone + templateInfoPanelContatoWhatsApp + templateInfoPanelContatoEmail + templateInfoPanelContatoEndereco + templateInfoPanelContatoLinkEndereco + templateFinal;

      let emails = new Set<string>(); // Inicializa um Set vazio para evitar duplicatas

      emails.add(agendamentoObj.emailMotorista.valor); // Adiciona o e-mail do motorista

      const id_obj = this.agendas.findIndex(ag => ag.id === agendamentoObj.agendaId);

      if (id_obj !== -1 && this.agendas[id_obj].notificacoes.valor) {
        this.agendas[id_obj].notificacoes.emails!.forEach(email => emails.add(email)); // Adiciona e-mails sem repetição
      }

      const emailsArray = Array.from(emails); // Converte o Set de volta para array

      this.localhostService.enviarEmailAgendamento(emailsArray, `Agendamento - Nota Fiscal ${agendamentoObj.notaFiscal.valor}`, template);
    }
  }

  async enviarEmailAgendamentoNaoAtendido(agendamentoObj: any){
    // console.log(agendamentoObj)

    if(this.empresaSigla != ''){
      const conta = await this.conta.p_getSiglaConta('contas', this.empresaSigla);
      // console.log(conta)
      const templateInicio = `<!DOCTYPE html PUBLIC ' -//W3C//DTD XHTML 1.0 Transitional//EN' 'http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd'> <html xmlns='http://www.w3.org/1999/xhtml'> <head> <!--[if mso]> <style> h2 { font-weight:bold; } h4 { font-weight:bold; } </style> <![endif]--> <title>LOGWISE</title> <meta http-equiv='content-type' content='text/html; charset=utf-8' /> <meta name='viewport' content='width=device-width, initial-scale=1.0' /> <link href='https://fonts.googleapis.com/css?family=Roboto:400,500,700' rel='stylesheet' /> <style type='text/css'> * { -ms-text-size-adjust: 100%; -webkit-text-size-adjust: none; -webkit-text-resize: 100%; text-resize: 100%; } html { font-size: 100%; -webkit-text-size-adjust: 100%; font-variant-ligatures: none; -webkit-font-variant-ligatures: none; text-rendering: optimizeLegibility; -moz-osx-font-smoothing: grayscale; font-smoothing: antialiased; -webkit-font-smoothing: antialiased; text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px; } body { font-family: 'Roboto', sans-serif, 'Arial'; } a { cursor: pointer !important; outline: none; color: #0361ff !important; text-decoration: none; -webkit-transition: all 0.3s ease; -moz-transition: all 0.3s ease; -ms-transition: all 0.3s ease; transition: all 0.3s ease; } a:hover { text-decoration: none !important; opacity: 0.9; } h2 { font-size: 18px; margin: 0; } h4 { font-size: 14px; margin: 0; } h5 { font-size: 13px; margin: 0; } span { line-height: 18px; } #info-panel span, #info-panel p { font-weight: 400; } #info-panel h4 { line-height: 24px; } .panel { padding: 15px 15px 15px; min-width: 280px; border-radius: 15px;} .title a:hover { text-decoration: underline !important; } .title-2 a:hover { text-decoration: underline !important; } .legal { line-height: 16px; } .btn:hover { opacity: 0.9; } .btn a:hover { text-decoration: none !important; } table td { border-collapse: collapse !important; } .ExternalClass, .ExternalClass a, .ExternalClass span, .ExternalClass b, .ExternalClass br, .ExternalClass p, .ExternalClass div { line-height: inherit; } @media only screen and (max-width: 500px) { table[class='legal'] { line-height: normal !important; } } @media only screen and (max-width: 500px) { table[class='flexible'] { width: 100% !important; } } @media only screen and (max-width: 500px) { table[class='center'] { float: none !important; margin: 0 auto !important; } } @media only screen and (max-width: 500px) { [class='hide'] { display: none !important; width: 0 !important; height: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important; } } @media only screen and (max-width: 500px) { td[class='aligncenter'] { text-align: center !important; } } @media only screen and (max-width: 500px) { th[class='flex'] { display: block !important; width: 100% !important; } } @media only screen and (max-width: 500px) { td[class='wrapper'] { padding: 0 !important; } } @media only screen and (max-width: 500px) { td[class='holder'] { padding: 30px 15px 20px !important; } } @media only screen and (max-width: 500px) { td[class='h-auto'] { height: auto !important; } } @media only screen and (max-width: 500px) { td[class='description'] { padding: 30px 20px !important; } } @media only screen and (max-width: 500px) { td[class='i-120'] img { width: 120px !important; height: auto !important; } } @media only screen and (max-width: 500px) { td[class='footer'] td[class='aligncenter'] { line-height: 25px !important; padding: 0 !important; } } @media only screen and (max-width: 500px) { tr[class='table-holder'] { display: table !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='thead'] { display: table-header-group !important; width: 100% !important; } } @media only screen and (max-width: 500px) { th[class='tfoot'] { display: table-footer-group !important; width: 100% !important; } } </style> </head> <body style='margin:0; padding:0;' bgcolor='#ebeff3'> <table style='min-width:320px;' width='100%' cellspacing='0' cellpadding='0' bgcolor='#ebeff3' > <!-- fix for gmail --> <tr> <td class='hide'> <table width='600' cellpadding='0' cellspacing='0' style='width:600px !important;' > <tr> <td style='min-width:600px;font-size:0;line-height:0;'></td> </tr> </table> </td> </tr> <tr> <td class='wrapper' style='padding:30px 10px 0 10px;'> <!-- MAIN BODY --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' style='padding: 0px 0px 0px;border-radius: 5px;background: linear-gradient(0deg,#ffffff 0%,#ffffff 100%);border: 1.5px solid #ececec;box-shadow: rgb(0 0 0 / 5%) 0px 6px 12px;' bgcolor='#FFFFFF' > <table width='100%' cellpadding='0' cellspacing='0'>`
      const templateLogo = `<!-- Logo --> <tr> <td class='logo' align='center'> <img src='${conta.logoURL.valor}' style='vertical-align:top; width: 169px; margin-bottom: 30px; margin-top: 50px;' alt='bSC35mL.jpg' /> </td> </tr>`;
      const templateHeadingTitle = `<!-- Heading Title --> <tr> <td align='center' style='font-weight:500 !important;' > <h2 style='color:#333240;line-height:21px;'> Agendamento </h2> </td> </tr>`;
      const templateInfoPanelInicio = `<!-- Info Panel --> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' >`;
      const templateInfoPanelTitle = `<h4>Nota Fiscal ${agendamentoObj.notaFiscal.valor}</h4><span>`;
      const templateInfoPanelMensagem = `<br> Seu agendamento para o dia <strong>${agendamentoObj.dataAtendimento.valor}</strong> às <strong>${agendamentoObj.hora_inicial.valor}</strong> teve uma atualização: <br><br>`;

      let corBg = '';
      let corTxt = '';

      switch (agendamentoObj.status.valor) {
        case 'Confirmado Cliente':
          corBg = '#ffc107';
          corTxt = '#fff';
          break;
        case 'Confirmado Administrador':
          corBg = '#1a68bf';
          corTxt = '#fff';
          break;
        case 'Atendido':
          corBg = '#38a713';
          corTxt = '#fff';
          break;
        case 'Não Atendido':
          corBg = '#d6050b';
          corTxt = '#fff';
          break;
        default:
          corBg = '#333240';
          corTxt = '#fff';
          break;
      }

      const templateInfoPanelStatus = `<span style='display: block;margin-bottom: 5px;'>Status do agendamento</span> <span style='background:${corBg};padding:3px 10px 2px;border:2px solid ${corBg};border-radius:15px!important;color:${corTxt};text-transform:uppercase;letter-spacing:1px;font-weight: 600;display:block;text-align:center;font-size: 13px;'>${agendamentoObj.status.valor}</span><br>`;

      const templateInfoPanelMotivo = `<strong>Motivo:</strong><br> ${agendamentoObj.observacao.valor} <br><br>`;

      const templateInfoPanelInfo = `Seu agendamento foi finalizado.<br>Obrigado.<br> </span>`;
      const templateInfoPanelFinal = `</td></tr></table></td></tr>`;

      const templateSeparador = `<tr> <td><hr style='margin-top: 25px;border: 0px solid !important;border-top: 1px dashed #eceff3 !important;'></td> </tr>`;

      const templateInfoPanelContato = `<!-- Info Panel Contato--> <tr id='info-panel'> <td style='padding:16px 10px 0px 10px;'> <table align='center' style='margin:0 auto;max-width:420px; padding:0px 0px 50px 0px;' cellpadding='0' cellspacing='0' > <tr> <td class='panel' align='center' style='font-size:14px;color:#333240;font-weight:500 !important;border-radius:5px;border:0px solid #eceff3;text-align:left;mso-padding-alt:12px 10px 10px;' > <h4>Ficou com dúvidas?</h4> <p style='font-size: 13px; margin: 0px;'>Entre em contato conosco pelos seguintes canais de atendimento:</p> <span> <!-- === CHANGE ME === --> <br>`;

      let templateInfoPanelContatoTelefone = ``;
      let templateInfoPanelContatoWhatsApp = ``;
      let templateInfoPanelContatoEmail = ``;

      if(conta.telefone.valor != ""){
        templateInfoPanelContatoTelefone = `<h4>Telefone</h4> <a target='_blank' href='tel:0${conta.telefone.valor.replace(/\D/g, "")}'>${conta.telefone.valor}</a> <br><br>`;
      }

      if(conta.whatsapp.valor != ""){
        templateInfoPanelContatoWhatsApp = `<h4>WhatsApp</h4> <a target='_blank' href='https://api.whatsapp.com/send?phone=55${conta.whatsapp.valor.replace(/\D/g, "")}&text=Agendamento%20Nota%20${agendamentoObj.notaFiscal.valor}'>${conta.whatsapp.valor}</a> <br><br>`;
      }

      if(conta.email.valor != ""){
        templateInfoPanelContatoEmail = `<h4>E-mail</h4> <a target='_blank' href='mailto:${conta.email.valor}'>${conta.email.valor}</a> <br><br>`
      }

      const templateInfoPanelContatoEndereco = `<h4>Endereço</h4> ${conta.logradouro.valor} ${conta.numero.valor}, ${conta.bairro.valor}<br> ${conta.localidade.valor}-${conta.uf.valor} - ${conta.cep.valor}<br> ${conta.complemento.valor}<br><br>`;

      const linkComoChegar = this.gerarLinkMaps(conta.logradouro.valor, conta.numero.valor, conta.bairro.valor, conta.localidade.valor, conta.uf.valor, conta.cep.valor);

      const templateInfoPanelContatoLinkEndereco = `<a  target='_blank' class='btn' style='margin-top: 5px;margin-bottom: 5px;display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: center;font-size: 10px !important;padding: 4px 8px !important;font-weight: 500;letter-spacing: .4px;background: #f46221;color: #fff !important;width: 100px;border-radius: 5px;' href='${linkComoChegar}'> Como chegar ? </a>`
      // gerarLinkMaps(logradouro: string, numero: string, bairro: string, localidade: string, uf: string, cep: string)

      const templateFinal = `</span> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> <!-- FOOTER --> <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td bgcolor='#ebeff3'> <table class='flexible' width='600' align='center' style='margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td class='footer'> <table width='100%' cellpadding='0' cellspacing='0'> <tr class='table-holder'> <th class='tfoot' width='400' align='center' style='vertical-align:top;padding:0;' > <table width='100%' cellpadding='0' cellspacing='0'> <tr> <td class='aligncenter legal' style='font-size: 12px;color: #444444;font-weight:400;text-align:center;padding: 25px 5px 0px 5px;' > Este e-mail e seus anexos são confidenciais e destinados exclusivamente ao destinatário indicado. Se você não é o destinatário dessa mensagem, qualquer leitura, uso, divulgação, cópia ou disseminação de toda ou parte desta mensagem e/ou os anexos associados são expressamente proibidos. </td> </tr> </table> <table width='100%' cellpadding='0' cellspacing='0' class='center' > <tr> <td height='15'></td> </tr> <tr> <td style='padding:0 10px 0 0;'> <table width='155' align='center' style='height:45px;margin:0 auto;' cellpadding='0' cellspacing='0' > <tr> <td align='center' style='background-repeat:no-repeat;' > <img src='https://firebasestorage.googleapis.com/v0/b/logwise-dev-9cf97.appspot.com/o/logwise%2Flogwise-logo-padrao-branco.png?alt=media' style='width: 130px;'/> </td> </tr> </table> </td> </tr> <tr> <td height='50'></td> </tr> </table> </th> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <!-- fix for gmail --> <tr> <td style='line-height:0;'> <div style='display:none;white-space:nowrap;font:15px/1px courier;' ></div> </td> </tr> </table> </body> </html>`

      const template = templateInicio + templateLogo + templateHeadingTitle + templateInfoPanelInicio + templateInfoPanelTitle + templateInfoPanelMensagem + templateInfoPanelStatus + templateInfoPanelMotivo + templateInfoPanelInfo + templateInfoPanelFinal + templateSeparador + templateInfoPanelContato + templateInfoPanelContatoTelefone + templateInfoPanelContatoWhatsApp + templateInfoPanelContatoEmail + templateInfoPanelContatoEndereco + templateInfoPanelContatoLinkEndereco + templateFinal;

      let emails = new Set<string>(); // Inicializa um Set vazio para evitar duplicatas

      emails.add(agendamentoObj.emailMotorista.valor); // Adiciona o e-mail do motorista

      const id_obj = this.agendas.findIndex(ag => ag.id === agendamentoObj.agendaId);

      if (id_obj !== -1 && this.agendas[id_obj].notificacoes.valor) {
        this.agendas[id_obj].notificacoes.emails!.forEach(email => emails.add(email)); // Adiciona e-mails sem repetição
      }

      const emailsArray = Array.from(emails); // Converte o Set de volta para array

      this.localhostService.enviarEmailAgendamento(emailsArray, `Agendamento - Nota Fiscal ${agendamentoObj.notaFiscal.valor}`, template);
    }
  }

  gerarLinkMaps(logradouro: string, numero: string, bairro: string, localidade: string, uf: string, cep: string){

    let partesURL = "";

    if(logradouro){
      partesURL += `${logradouro},`;
    }

    if(numero){
      partesURL += `+${numero}`;
    }

    if(bairro){
      partesURL += `+-+${bairro},`;
    }

    if(localidade){
      partesURL += `+${localidade}`;
    }

    if(uf){
      partesURL += `+-+${uf},`;
    }

    if(cep){
      partesURL += `+${cep}`;
    }

    // Concatenar as partes da URL com "+" e adicionar os espaços
    const urlFormatada = encodeURIComponent(partesURL);

    // Construir a URL completa
    const urlCompleta = `https://maps.google.com/?q=${urlFormatada}`;
    return urlCompleta.replace(/%20/g, '+').replace(/%2C/g, ',').replace(/%2B/g,'+');

  }

  abrirModal(event: any) {
    // Ativar o modal usando a biblioteca do Bootstrap
    // const modal = new bootstrap.Modal(event);
    // modal.show();
    const modalElement = event;
    if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        this.modalsMap.set(event, modalInstance); // Armazenar a instância do modal no mapa
        modalInstance.show();
    } else {
        // console.error("Elemento do modal não encontrado");
    }
  }

  fecharModal(event: any){
    // console.log(event)
    // const modal = new bootstrap.Modal(event);
    // modal.hide();
    const modalInstance = this.modalsMap.get(event);
    if (modalInstance) {
        modalInstance.hide(); // Fechar o modal
    } else {
        // console.error("Instância do modal não encontrada");
    }
  }

  async naoAtendido(id: any){
    const index = this.agendamentos.findIndex((item: Agendamento) => item.id === id);

    this.naoAtendidoObj.observacao.status = this.validatorService.criarValidacao(this.naoAtendidoObj.observacao.valor, this.naoAtendidoObj.observacao.validacoesCustomizadas);

    if(this.naoAtendidoObj.observacao.status.invalid){
      // console.log(this.naoAtendidoObj.observacao.status)
    }else{

      if (index !== -1) {
        this.naoAtendidoObj.status.valor = this.statusAgendamento.naoAtendido;
        this.agendamentos[index] = this.naoAtendidoObj;

        this.agendamentos[index].statusExecucao.valor = this.agendamentos[index].statusExecucaoOptions[1].nome;

        const docId = this.agendamentos[index].id != null ? this.agendamentos[index].id?.toString() : "";
        const plainObject = JSON.stringify(this.agendamentos[index])
        const plainString = JSON.parse(plainObject)

        plainString.cpfMotorista.status = null;
        plainString.dataAtendimento.status = null;
        plainString.duracaoAtendimento.status = null;
        plainString.emailMotorista.status = null;
        plainString.fornecedor.status = null;
        plainString.hora_final.status = null;
        plainString.hora_inicial.status = null;
        plainString.nomeMotorista.status = null;
        plainString.notaFiscal.status = null;
        plainString.numeroPedido.status = null;
        plainString.observacao.status = null;
        plainString.placaVeiculo.status = null;
        plainString.telefoneMotorista.status = null;
        plainString.status.status = null;
        plainString.statusExecucao.status = null;

        await this.conta.p_getSiglaConta('contas', this.empresaSigla)
        .then((conta) => {
          // Faça algo com os dados obtidos
          // console.log('Dados da conta: criarAgenda', conta);

          this.localhostService.putDados(`${conta.id}_agendamentos`, docId! , plainString)
          .then(async (response: any) => {
            // console.log('Atualização bem-sucedida:', response);
            // Salve o array de volta no DataService
            // DataService.set("Agenda", this.agendas)
            // localStorage.setItem("Agenda", JSON.stringify(this.agendas))
            this.showSuccess(`Status do agendamento NF ${this.agendamentos[index].notaFiscal.valor} alterado para ${this.agendamentos[index].status.valor }`);

            // Nova notificação
            // 1 - empresaSigla: any,
            // 2 - titulo: string,
            // 3 - texto: string,
            // 4 - rotaSemParamNome: string,
            // 5 - rotaSemParamListar: string,
            // 6 - rotaComParamNome: string = "",
            // 7 - rotaComParamCaminho: string = "",
            // 8 - rotaComParamParam: string = "",
            // 9 - linkExternoNome: string = "",
            // 10 - linkExternoURL: string = "",
            // 11 - idReferencia: string,
            // 12 - tipo: string,
            // 13 - idResponsavel: string,
            // 14 - nomeResponsavel: string

            const usr = await this.userService.carregarUsuario(this.empresaSigla)

            this.notificacaoService.criarNotificacao(
              this.empresaSigla,
              `NF ${this.agendamentos[index].notaFiscal.valor}`,
              `O status do agendamento do dia ${this.agendamentos[index].dataAtendimento.valor}, das ${this.agendamentos[index].hora_inicial.valor} às ${this.agendamentos[index].hora_final.valor}, foi alterado para ${this.agendamentos[index].status.valor}.`,
              'Listar Agendamentos',
              'agendamentos',
              'Editar Agendamento',
              `agendamentos/agendamento`,
              this.agendamentos[index].id!.toString(),
              '',
              '',
              this.agendamentos[index].agendaId!.toString(),
              `Agendamento`,
              `${usr.id}`,
              `${usr.displayName.valor}`
            )

            this.enviarEmailAgendamentoNaoAtendido(this.agendamentos[index]);

          })
          .catch((error: any) => {
            // console.error('Erro ao atualizar dados:', error);
            this.showError("Agendamento não encontrado para atualização \n" + error);
          });
        },
        (error: any) => {
          // console.error('Erro ao atualizar dados:', error);
          // Trate o erro conforme necessário
        }).catch((error) => {
          // Trate o erro
          // this.authService.fazerLogout(this.empresaSigla);
          // console.log('Erro ao obter dados da conta:', error);
        });

        // localStorage.setItem("Agendamento", JSON.stringify(this.agendamentos))
        // this.showSuccess(`Agendamento ${this.agendamentos[index].status.valor}`);
      } else {
        // O item não foi encontrado no array, você pode tratar isso conforme necessário
        this.showError("Agendamento não encontrada para atualização");
      }
    }
  }

  ordenadoPor(param: string): void {
    let sortedAgendamentos: Agendamento[] = [];
    this.classificado = param;

    switch (param) {
      case "Maior Data/Horário":
        sortedAgendamentos = this.agendamentos.sort((a, b) => this.compareData(b, a));
        break;
      case "Menor Data/Horário":
        sortedAgendamentos = this.agendamentos.sort((a, b) => this.compareData(a, b));
        break;
      default:
        break;
    }

    this.agendamentos = sortedAgendamentos

    this.displayedAgendamentos = sortedAgendamentos.slice(
    this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );

  }

  statusPor(param: string): void {
    // console.log("PARAM", param);
    // console.log("dataAgendamento", this.dataAgendamento);
    this.status = param;

    // let statusAgendamentos: Agendamento[] = [];

    switch (param) {
      case "":
        // console.log("switch PARAM", param);
        if(this.dataAgendamento == 'Hoje'){
          this.agendamentosDia();
        }else if(this.dataAgendamento == 'Futuros'){
          this.agendamentosFuturos();
        }else if(this.dataAgendamento == 'Passados'){
          this.agendamentosPassados();
        }else{
          this.allAgendamentos();
        }
        break;
      default:
        // console.log("switch PARAM", param);
        if(this.dataAgendamento == 'Hoje'){
          this.agendamentoService.getStatusAgendamentoDia(param)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (agendamentos: Agendamento[]) => {
              // Atualiza a propriedade agendamentos com os resultados do observable
              this.agendamentos = agendamentos;
              this.ordenadoPor(this.classificado);
            },
            error => {
              // console.error('Erro ao obter agendamentos por status:', error);
            }
          );
        }else if(this.dataAgendamento == 'Futuros'){
          this.agendamentoService.getStatusAgendamentosFuturos(param)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (agendamentos: Agendamento[]) => {
              // Atualiza a propriedade agendamentos com os resultados do observable
              this.agendamentos = agendamentos;
              this.ordenadoPor(this.classificado);
            },
            error => {
              // console.error('Erro ao obter agendamentos por status:', error);
            }
          );
        }else if(this.dataAgendamento == 'Passados'){
          this.agendamentoService.getStatusAgendamentosPassados(param)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (agendamentos: Agendamento[]) => {
              // Atualiza a propriedade agendamentos com os resultados do observable
              this.agendamentos = agendamentos;
              this.ordenadoPor(this.classificado);
            },
            error => {
              // console.error('Erro ao obter agendamentos por status:', error);
            }
          );
        }else{
          this.agendamentoService.getStatusAgendamento(param)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (agendamentos: Agendamento[]) => {
              // Atualiza a propriedade agendamentos com os resultados do observable
              this.agendamentos = agendamentos;
              this.ordenadoPor(this.classificado);
            },
            error => {
              // console.error('Erro ao obter agendamentos por status:', error);
            }
          );
        }

        break;
    }

    this.displayedAgendamentos = this.agendamentos.slice(
      this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );

  }

  private compareHorario(agendamentoA: Agendamento, agendamentoB: Agendamento): number {
    const horarioA = agendamentoA.hora_inicial.valor; // Supondo que 'horario' seja uma string no formato 'hh:mm'
    const horarioB = agendamentoB.hora_inicial.valor;

    return horarioA.localeCompare(horarioB);
  }

  private compareData(agendamentoA: Agendamento, agendamentoB: Agendamento): number {
    const dataA = this.parseDataString(agendamentoA.dataAtendimento.valor, agendamentoA.hora_inicial.valor);
    const dataB = this.parseDataString(agendamentoB.dataAtendimento.valor, agendamentoB.hora_inicial.valor);

    return dataA.getTime() - dataB.getTime();
  }

  private parseDataString(dataString: string, horaString: string): Date {
    const partesData = dataString.split("/");
    const horario = horaString.split(":"); // Supondo que 'horario' seja uma string no formato 'hh:mm'

    return new Date(
      parseInt(partesData[2]),
      parseInt(partesData[1]) - 1,
      parseInt(partesData[0]),
      parseInt(horario[0]),
      parseInt(horario[1])
    );
  }

  async openCalendario(){

    this.loader.start();
    this.abrirModal(this.calendarioModal.nativeElement);
    this.fullcalendar.getApi().setOption('height', 'auto');
    this.fullcalendar.getApi().updateSize();
    this.loader.complete();


  }

  async carregarCalendario() {
    // Faça algo com a mudança de agendaSelecionada
    if(this.agendaSelecionada){
      // console.log(this.agendaSelecionada);

      let agenda: any = {};

      for (let index = 0; index < this.agendas.length; index++) {
        const agd = this.agendas[index];
        if(agd.id == this.agendaSelecionada){
          Object.assign(agenda, agd);
          break;
        }
      }
      // console.log(agenda)

      const dataString_dataInicial = agenda.agenda_inicio.valor;
      const partesData_dataInicial = dataString_dataInicial.split("/");

      const dataString_dataFinal = agenda.agenda_fim.valor;
      const partesData_dataFinal = dataString_dataFinal.split("/");

      const dataInicial = new Date(partesData_dataInicial[2], partesData_dataInicial[1] - 1, partesData_dataInicial[0]);
      const dataFinal = new Date(partesData_dataFinal[2], partesData_dataFinal[1] - 1, partesData_dataFinal[0], 23, 59, 59);

      // console.log(dataInicial, dataFinal)

      const duracao = agenda.duracaoAtendimento.valor;
      const horario = agenda.horarios;

      const nomeAgenda = agenda.nome.valor;

      const ret = await this.calendarioService.gerarEventosAgendamento(dataInicial,dataFinal,duracao,horario,nomeAgenda, this.agendaSelecionada, this.empresaSigla)

      // console.log(ret)
      // console.log(this.agendamentos.length)

      this.calendarOptions.now = new Date();

      // let agendamentosC: any = [];

      // this.agendamentoService.getAllAgendamentos()
      // .pipe(takeUntil(this.destroy$))
      // .subscribe(
      //   async (agendamentos: Agendamento[]) => {
      //     // console.log(agendamentos)

      //     // Faça algo com as notificações atualizadas
      //     // if(agendamentos.length > 0){
      //       agendamentosC = agendamentos;
      //       for (let index = 0; index < agendamentosC.length; index++) {
      //         const element = agendamentosC[index];
      //         if(this.agendaSelecionada == element.agendaId){
      //           console.log(element)
      //           const dataISOString = await this.criarISODateTime(element.dataAtendimento.valor, element.hora_inicial.valor);
      //           console.log(dataISOString)
      //           for (let j = 0; j < ret.length; j++) {
      //             const elementJ = ret[j];

      //             const comp1 = new Date(elementJ.start).getTime();
      //             const comp2 = new Date(dataISOString).getTime();

      //             if(comp1 == comp2){
      //               console.log(comp1 + " == " + comp2)
      //               console.log(elementJ.start + " == " + dataISOString)
      //               elementJ.idAgendamento = element.id;
      //               elementJ.title = `Nota Fiscal ${element.notaFiscal.valor}`;
      //               element.backgroundColor = "var(--cor-sucesso)",
      //               element.color = "var(--cor-sucesso)"
      //               break;
      //             }

      //           }
      //         }
      //       }

      //     this.calendarOptions.events = ret;

      //   },
      //   error => {
          // console.error('Erro ao listar os Agendamentos:', error);
      //   }
      // );



      this.calendarOptions.events = ret;

      this.loader.complete()
    }else{
      this.showError("Selecione uma agenda")
    }
  }

  // Função para atualizar a lista de eventos
  updateEvents() {

    this.calendarOptions.events = this.eventsList;
    // this.reloadCalendar();

  }

  // Manipulador de eventos quando um evento é clicado
  handleEventClick(info: any) {
    // Aqui, você pode adicionar lógica para editar ou remover o evento
    // Por exemplo, exibir um modal para editar o evento
    // console.log(info.event);

    if(info.event.extendedProps.idAgendamento != ""){
      this.infoAgendamento(info.event.extendedProps.idAgendamento);
      // console.log(this.modalsMap)
    }else{
      const currentDateI = new Date(info.event._instance.range.start);
      currentDateI.setHours(currentDateI.getHours() + 3);
      // console.log(currentDateI);
      const currentDateF = new Date(info.event._instance.range.end);
      currentDateF.setHours(currentDateF.getHours() + 3);
      // console.log(currentDateF);

      const diaInicio = `${currentDateI.getDate().toString().padStart(2, '0')}/${(currentDateI.getMonth() + 1).toString().padStart(2, '0')}/${currentDateI.getFullYear()}`;

      // Extrair informações da data inicial
      const horaInicio = currentDateI.getHours().toString().padStart(2, '0');
      const minutosInicio = currentDateI.getMinutes().toString().padStart(2, '0');

      // Extrair informações da data final
      const horaFim = currentDateF.getHours().toString().padStart(2, '0');
      const minutosFim = currentDateF.getMinutes().toString().padStart(2, '0');

      this.showError(`${info.event._def.title.replace('- ', '')}, dia ${diaInicio}, das ${horaInicio}:${minutosInicio} às ${horaFim}:${minutosFim}. Não há agendamentos programados para este horário`)
    }
  }

  // Função para adicionar um novo evento à lista
  addEvent() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    const second = now.getSeconds().toString().padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}`;


    const newEvent = {
      title: 'Novo Evento',
      start: formattedDate,
      end: formattedDate,
      backgroundColor: 'var(--cor-primaria)',
    };

    this.eventsList.push(newEvent);
    // this.updateEvents();
  }

  // Função para editar um evento existente
  editEvent(event: any) {
    // Implemente a lógica para editar o evento aqui
    // Por exemplo, exibir um modal de edição
    console.log('Editar evento:', event);
  }

  // Função para excluir um evento existente
  deleteEvent(event: any) {
    const index = this.eventsList.indexOf(event);
    if (index !== -1) {
      this.eventsList.splice(index, 1);
      this.updateEvents();
    }
  }

  // Função para recarregar o calendário
  reloadCalendar() {
    if (this.fullcalendar) {
      this.fullcalendar.getApi().refetchEvents();
    }
  }

  customEventContent(arg: EventContentArg) {
    // Defina um tamanho fixo para as caixas de eventos
    const eventElement = document.createElement('div');
    // eventElement.style.width = '100px'; // Defina o tamanho desejado em pixels
    eventElement.style.height = '30px'; // Defina o tamanho desejado em pixels
    eventElement.style.display = 'flex';
    eventElement.style.alignItems = 'center';
    eventElement.style.paddingLeft = '5px';

    // Crie o conteúdo do evento (por exemplo, o título)
    const eventTitle = document.createElement('div');
    eventTitle.innerText = arg.event.title;

    // Adicione o conteúdo ao elemento do evento
    eventElement.appendChild(eventTitle);

    return { domNodes: [eventElement] };
  }

  customDatesSet(info: DatesSetArg) {
    if (info.view.type === 'dayGridMonth') {
      // Defina o tamanho desejado para as células do dia no modo mês
      const dayCellElements = document.querySelectorAll('.fc-daygrid-day');
      dayCellElements.forEach((element:any) => {
        element.style.maxHeight = '100px'; // Defina o tamanho máximo desejado em pixels
      });
    }
  }

  resetEventosCalendario(){
    this.calendarOptions.events = [];
  }

  async criarISODateTime(dataString: any, horaString: any){
    const dataStr = dataString;
    const horaStr = horaString;

    const partesData = dataStr.split("/");
    const dia = parseInt(partesData[0], 10);
    const mes = parseInt(partesData[1], 10) - 1;
    const ano = parseInt(partesData[2], 10);

    const partesHora = horaStr.split(":");
    const hora = parseInt(partesHora[0], 10);
    const minuto = parseInt(partesHora[1], 10);

    const dataHora = new Date(ano, mes, dia, hora, minuto);

    const currentDate = dataHora;
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hours = String(currentDate.getHours() + 3).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(currentDate.getMilliseconds()).padStart(3, '0');

    const isoDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    // console.log("Data e Hora:", dataHora);
    // console.log(isoDateTime);
    return isoDateTime
  }

  async infoAgendamento(agendamentoID: any){

    const agendamento = await this.agendamentoService.p_getAgendamentoID(this.empresaSigla, agendamentoID);

    this.objInfoAgendamento = Object.assign(new Agendamento(), agendamento);

    // console.log(agendamento)

    for (let index = 0; index < this.agendas.length; index++) {
      const element = this.agendas[index];
      if(element.id == this.objInfoAgendamento.agendaId){
        this.objInfoAgenda = Object.assign(new Agenda(), element);

      }
    }
    this.fecharModal(this.calendarioModal.nativeElement);

    this.abrirModal(this.infoAgendamentoModal.nativeElement);
  }

  async criarCheckin() {

    this.validarCampo(this.new_checkin.nomeMotorista);
    this.validarCampo(this.new_checkin.cpfMotorista);
    this.validarCampo(this.new_checkin.placaVeiculo);
    this.validarCampo(this.new_checkin.veiculo);
    this.validarCampo(this.new_checkin.peso);
    this.validarCampo(this.new_checkin.telefoneMotorista);
    this.validarCampo(this.new_checkin.emailMotorista);
    this.validarCampo(this.new_checkin.notaFiscal);
    this.validarCampo(this.new_checkin.numeroPedido);
    this.validarCampo(this.new_checkin.fornecedor);

    if(this.new_checkin.whatsapp.status && this.telefoneFormControl.invalid){
      this.showError("Alguns campos precisam ser preenchidos.");
    }else if(this.new_checkin.pager.status && this.pagerFormControl.invalid){
      this.showError("Alguns campos precisam ser preenchidos.");
    }else if(this.temErrosCheckin()){
      this.showError("Alguns campos precisam ser preenchidos.");
    }else{
      // console.log(this.new_checkin);

      // console.log(this.agendamentos)
      const index = this.agendamentos.findIndex((item: Agendamento) => item.id === this.new_checkin.atendimentoId);

      if (index !== -1) {
        const horaInicial = this.agendamentos[index].hora_inicial.valor;
        // console.log(this.agendamentos[index].statusExecucao.valor)

        if (this.agendamentos[index].statusExecucao.valor.trim() === '') {
          // Obtém a data e hora atuais
          const agora = new Date();
          const horaAtual = agora.getHours();
          const minutosAtuais = agora.getMinutes();

          // Converte dataAtendimento para um objeto Date (dd/mm/aaaa)
          const [dia, mes, ano] = this.agendamentos[index].dataAtendimento.valor.split('/').map(Number);
          const dataAtendimento = new Date(ano, mes - 1, dia);

          // Verifica se a data de atendimento é no futuro
          if (dataAtendimento > agora) {
            // Data de atendimento é futura, configura status para opção futura
            const statusExecucao = this.agendamentos[index].statusExecucao.valor === ''
              ? this.agendamentos[index].statusExecucaoOptions[0].nome
              : this.agendamentos[index].statusExecucao.valor;
            this.agendamentos[index].statusExecucao.valor = statusExecucao;
          } else if (dataAtendimento.toDateString() === agora.toDateString()) {
            // Data de atendimento é hoje, compara as horas
            const [hora, minutos] = horaInicial.split(':').map(Number);

            if (horaAtual < hora || (horaAtual === hora && minutosAtuais <= minutos)) {
              // Hora atual é igual ou menor que a hora_inicial
              const statusExecucao = this.agendamentos[index].statusExecucao.valor === ''
                ? this.agendamentos[index].statusExecucaoOptions[0].nome
                : this.agendamentos[index].statusExecucao.valor;
              this.agendamentos[index].statusExecucao.valor = statusExecucao;
            } else {
              // Hora atual é maior que a hora_inicial
              const statusExecucao = this.agendamentos[index].statusExecucao.valor === ''
                ? this.agendamentos[index].statusExecucaoOptions[3].nome
                : this.agendamentos[index].statusExecucao.valor;
              this.agendamentos[index].statusExecucao.valor = statusExecucao;
            }
          } else {
            // Data de atendimento é no passado
            const statusExecucao = this.agendamentos[index].statusExecucao.valor === ''
              ? this.agendamentos[index].statusExecucaoOptions[3].nome
              : this.agendamentos[index].statusExecucao.valor;
            this.agendamentos[index].statusExecucao.valor = statusExecucao;
          }
        }

        this.agendamentos[index].status.valor = this.statusAgendamento.atendido;

        const docId = this.agendamentos[index].id != null ? this.agendamentos[index].id?.toString() : "";
        const agendamentoEditadoObject = JSON.stringify(this.agendamentos[index])
        const agendamentoEditadoString = JSON.parse(agendamentoEditadoObject)

        agendamentoEditadoString.nomeMotorista.valor = this.new_checkin.nomeMotorista.valor;
        agendamentoEditadoString.cpfMotorista.valor = this.new_checkin.cpfMotorista.valor;
        agendamentoEditadoString.placaVeiculo.valor = this.new_checkin.placaVeiculo.valor;
        agendamentoEditadoString.veiculo.valor = this.new_checkin.veiculo.valor;
        agendamentoEditadoString.peso.valor = this.new_checkin.peso.valor;
        agendamentoEditadoString.telefoneMotorista.valor = this.new_checkin.telefoneMotorista.valor;
        agendamentoEditadoString.emailMotorista.valor = this.new_checkin.emailMotorista.valor;
        agendamentoEditadoString.notaFiscal.valor = this.new_checkin.notaFiscal.valor;
        agendamentoEditadoString.numeroPedido.valor = this.new_checkin.numeroPedido.valor;
        agendamentoEditadoString.fornecedor.valor = this.new_checkin.fornecedor.valor;

        agendamentoEditadoString.nomeMotorista.status = null;
        agendamentoEditadoString.cpfMotorista.status = null;
        agendamentoEditadoString.placaVeiculo.status = null;
        agendamentoEditadoString.veiculo.status = null;
        agendamentoEditadoString.peso.status = null;
        agendamentoEditadoString.telefoneMotorista.status = null;
        agendamentoEditadoString.emailMotorista.status = null;
        agendamentoEditadoString.notaFiscal.status = null;
        agendamentoEditadoString.numeroPedido.status = null;
        agendamentoEditadoString.fornecedor.status = null;
        agendamentoEditadoString.dataAtendimento.status = null;
        agendamentoEditadoString.duracaoAtendimento.status = null;
        agendamentoEditadoString.hora_inicial.status = null;
        agendamentoEditadoString.hora_final.status = null;
        agendamentoEditadoString.observacao.status = null;
        agendamentoEditadoString.status.status = null;
        agendamentoEditadoString.statusExecucao.status = null;

        await this.conta.p_getSiglaConta('contas', this.empresaSigla)
        .then((conta) => {

          this.localhostService.putDados(`${conta.id}_agendamentos`, docId! , agendamentoEditadoString)
          .then(async (response: any) => {

            this.showSuccess(`Status do agendamento NF ${this.agendamentos[index].notaFiscal.valor} alterado para ${this.agendamentos[index].status.valor }`);

            // Nova notificação
            // 1 - empresaSigla: any,
            // 2 - titulo: string,
            // 3 - texto: string,
            // 4 - rotaSemParamNome: string,
            // 5 - rotaSemParamListar: string,
            // 6 - rotaComParamNome: string = "",
            // 7 - rotaComParamCaminho: string = "",
            // 8 - rotaComParamParam: string = "",
            // 9 - linkExternoNome: string = "",
            // 10 - linkExternoURL: string = "",
            // 11 - idReferencia: string,
            // 12 - tipo: string,
            // 13 - idResponsavel: string,
            // 14 - nomeResponsavel: string

            const usr = await this.userService.carregarUsuario(this.empresaSigla)

            this.notificacaoService.criarNotificacao(
              this.empresaSigla,
              `NF ${this.agendamentos[index].notaFiscal.valor}`,
              `O status do agendamento do dia ${this.agendamentos[index].dataAtendimento.valor}, das ${this.agendamentos[index].hora_inicial.valor} às ${this.agendamentos[index].hora_final.valor}, foi alterado para ${this.agendamentos[index].status.valor}.`,
              'Listar Agendamentos',
              'agendamentos',
              'Editar Agendamento',
              `agendamentos/agendamento`,
              this.agendamentos[index].id!.toString(),
              '',
              '',
              this.agendamentos[index].agendaId!.toString(),
              `Agendamento`,
              `${usr.id}`,
              `${usr.displayName.valor}`
            )

            this.enviarEmailAgendamentoAtendido(this.agendamentos[index]);


            this.new_checkin.id = await this.contadorIndexService.contadorIndex();
            let new_checkin  = new Checkin();
            new_checkin = this.new_checkin;

            new_checkin.criado = new Date();
            new_checkin.atualizado = new Date();

            new_checkin.status.valor = new_checkin.statusCheckin[0].nome;

            new_checkin.statusAguardando.status = new_checkin.statusCheckin[0].nome;
            new_checkin.statusAguardando.inicio = new Date();

            const checkin = JSON.stringify(new_checkin);
            this.checkinService.criarCheckin(JSON.parse(checkin), this.empresaSigla)

            this.fecharModal(this.checkinModal.nativeElement);
          })
          .catch((error: any) => {
            // console.error('Erro ao atualizar dados:', error);
            this.showError("Agendamento não encontrado para atualização \n" + error);
          });
        },
        (error: any) => {
          // console.error('Erro ao atualizar dados:', error);
        }).catch((error) => {
          // this.authService.fazerLogout(this.empresaSigla);
          // console.log('Erro ao obter dados da conta:', error);
        });
      }else {
        // O item não foi encontrado no array, você pode tratar isso conforme necessário
        this.showError("Agendamento não encontrada para atualização");
      }

      // const titulo = `Deseja adicionar um comentário para o checkin?`;
      // const mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
      //                   <p class="ag-mb-5">
      //                     <span>NF ${this.new_checkin.notaFiscal.valor}</span>
      //                   </p>
      //                 </div>`;

      // this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
      //   if (confirmation) {
      //     console.log('SIM!');
      //   }else{
      //     console.log('NÃO!');
      //   }
      // });
    }
  }

  private validarCampo(campo: any){
    if(campo){
      campo.status = this.validatorService.criarValidacao(campo.valor, campo.validacoesCustomizadas);
    }
  }

  private temErrosCheckin(): boolean {
    return [
      this.new_checkin.nomeMotorista,
      this.new_checkin.cpfMotorista,
      this.new_checkin.placaVeiculo,
      this.new_checkin.veiculo,
      this.new_checkin.peso,
      this.new_checkin.telefoneMotorista,
      this.new_checkin.emailMotorista,
      this.new_checkin.notaFiscal,
      this.new_checkin.numeroPedido,
      this.new_checkin.fornecedor
    ].some(campo => campo?.status?.invalid);
  }

  onTelefoneChange(telefone: string): void {
    this.telefoneFormControl.setValue(telefone);
  }

  herdarNumero(){
    this.telefoneFormControl.setValue(this.new_checkin.telefoneMotorista.valor);
    this.new_checkin.whatsapp.whatsapp.telefone = this.new_checkin.telefoneMotorista.valor;
  }

  onPagerChange(pager: string): void {
    this.pagerFormControl.setValue(pager);
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }


}
